/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreMorseCreateAliases {
  CHECKBOX_ENDOVENOUS_DEVICE_OPTION = 'checkbox-endovenous-device-option',
  CHECKBOX_FALL_HISTORY_OPTION = 'checkbox-fall-history-option',
  CHECKBOX_HAS_COMORBIDITY_OPTION = 'checkbox-has-comorbidity-option',
  FIELD_AMBULATORY_AID = 'field-ambulatory-aid',
  FIELD_ENDOVENOUS_DEVICE_OPTION = 'field-endovenous-device-option',
  FIELD_FALL_HISTORY_OPTION = 'field-fall-history-option',
  FIELD_GAIT_CHARACTERISTIC = 'field-gait-characteristic',
  FIELD_HAS_COMORBIDITY_OPTION = 'field-has-comorbidity-option',
  FIELD_MENTAL_STATE = 'field-mental-state',
  FIELD_SETUP_DATE = 'field-setup-date',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_SCORE_MORSE_CREATE = 'form-score-morse-create',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_SETUP_DATE = 'input-setup-date',
  PANEL_BODY = 'panel-body',
  PANEL_SCORE_MORSE_CREATE = 'panel-score-morse-create',
  RADIO_GROUP_AMBULATORY_AID = 'radio-group-ambulatory-aid',
  RADIO_GROUP_GAIT_CHARACTERISTIC = 'radio-group-gait-characteristic',
  RADIO_GROUP_MENTAL_STATE = 'radio-group-mental-state',
  SCORE_MORSE_ADD_LAYOUT = 'score-morse-add-layout',
}
export { ScoreMorseCreateAliases };
